import { ReactElement, useEffect, useState, SyntheticEvent } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Tab, Tabs
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TabPanel from "../../../../components/tabPanel";
import { useSelector } from "react-redux";
import { IState } from "../../../../types";
import CustomConfigPanel from "./customConfigPanel";
import ParamsPanel from "./paramsPanel";
import { ICategoryField, IFamilyBase, IFamilyGroup, IKeyValue } from "../../types";
import { cloneObject } from "../../../../system/utils";
import CustomProductPanel from "./customProductPanel";


interface IProps {
  data: ICategoryField;
  family: IFamilyBase;
  onAccept: (data: ICategoryField) => void;
  onCancel: () => void;
  allowEdit: boolean;
}

const CustomConfigDialog = ({ data, onAccept, onCancel, allowEdit, family }: IProps): ReactElement => {
  const [tabSelected, setTabSelected] = useState(0);
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [editedData, setEditedData] = useState(cloneObject(data));
  const [params, setParams] = useState<IKeyValue[]>([]);
  const [right, setRight] = useState<IFamilyGroup[]>([]);

  useEffect(() => {
    const newObject = {
      ...editedData,
      custom: editedData.custom ?? [],
      customOptions: editedData.customOptions ?? { params: {} }
    };

    setEditedData(newObject);
    setRight(family.products.filter(x => newObject.custom.indexOf(x.familyGroupID) !== -1));
    setParams(Object.values(newObject.customOptions.params));
  }, []);


  const handleChange = (_event: SyntheticEvent<any>, newValue: number) => {
    setTabSelected(newValue);
  };

  const onInternalAccept = () => {
    editedData.custom = right.map(x => x.familyGroupID);

    const paramsObj: Record<string, IKeyValue> = {};
    params.forEach(p => paramsObj[p.key] = p);

    editedData.customOptions = { params: paramsObj };

    onAccept(editedData);
  };

  return (
    <Dialog onClose={onCancel}  open={true} maxWidth="lg" keepMounted={true}>
      <DialogTitle id="customized-dialog-title">
        Custom Config
      </DialogTitle>
      <DialogContent dividers={true} style={{ height: 510 }} >
        <Tabs
          value={tabSelected}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered={true}
          style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)", width: 575 }}>
          <Tab value={0} label={"General"} />
          <Tab value={1} label={"Products"} />
          <Tab value={2} label={"Parameters"} />
        </Tabs>

        <TabPanel value={tabSelected} index={0} style={{ alignSelf: "stretch",  display: "grid" }} >
          <CustomConfigPanel allowEdit={allowEdit} data={editedData} setData={setEditedData}/>
        </TabPanel>
        <TabPanel value={tabSelected} index={1} style={{ alignSelf: "stretch",  display: "grid" }} >
          <CustomProductPanel allowEdit={allowEdit} family={family} right={right} setRight={setRight}
            customProducts={editedData.custom ?? []}/>
        </TabPanel>
        <TabPanel value={tabSelected} index={2} style={{ alignSelf: "stretch",  display: "grid" }} >
          <ParamsPanel allowEdit={allowEdit} params={params} setParams={setParams}/>
        </TabPanel>
      </DialogContent>
      <DialogActions>
        <Button onClick={onInternalAccept} variant="contained" color="primary" startIcon={<CheckIcon />}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomConfigDialog;
